import { useEffect } from "react";
import { apiV2, selectUser } from "api/firebase";
import {
  CommonNotificationType,
  INotificationBaseMessage,
  IPayloadPasswordReset,
} from "@evennt-tech/api-v2-core";
import { useLogout } from "hooks/useLogout";

export const useAutoCatchPasswordReset = () => {
  const logout = useLogout();

  useEffect(() => {
    apiV2.notification.subscribe<
      INotificationBaseMessage<IPayloadPasswordReset>
    >({
      key: CommonNotificationType.RESET_PASSWORD,
      callback: async ({ payload }) => {
        if (!payload) return;

        const user = selectUser();
        if (user?.id === payload.userId) {
          await logout("password-reset");
        }
      },
    });

    return () =>
      apiV2.notification.unsubscribe({
        key: CommonNotificationType.RESET_PASSWORD,
      });
  }, [logout]);
};
